import { Injectable } from "@angular/core";
import { City } from "src/app/ui/models/domains/pbm/state/city";
import { StateAcronym } from "src/app/ui/models/domains/pbm/state/state-acronym";
import { AbstractParser } from "../../parser";

@Injectable()
export class CityParser extends AbstractParser<City[]> {
  parse(payload: any): City[] {
    const cities: Array<City> = [];
    if (payload) {
      payload.forEach((data) => {
        const city = new City();
        city.setDistrictCode(data.DistrictCode);
        city.setName(data.Name);
        city.setPopulation(data.Population);
        city.setStateAcronym(new StateAcronym(data.StateAcronym));
        city.setStateAcronymCode(data.StateAcronymCode);
        cities.push(city);
      });
    }
    return cities;
  }
}
